<template>
    <section class="date-section" aria-label="Choose a booking date">
        <div class="date-heading">
            <span class="month">{{ activeDate ? activeDate.monthName : '' }}</span>
            <span class="year">{{ activeDate ? activeDate.year : '' }}</span>
        </div>
        <div class="date-track">
            <button
                v-for="item in dates"
                :key="item.date"
                ref="dateItems"
                type="button"
                class="date-item"
                :class="{ active: item.date === selectedDate }"
                :data-date="item.date"
                @click="$emit('select', item.date)"
            >
                <span class="weekday">{{ item.week }}</span>
                <span class="day">{{ item.day }}</span>
                <span class="indicator"></span>
            </button>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BookingDateSection',
    props: {
        dates: {
            type: Array,
            default: () => []
        },
        selectedDate: {
            type: String,
            default: ''
        }
    },
    computed: {
        /** 返回日期栏当前激活的门店日期。 */
        activeDate() {
            return this.dates.find(item => item.date === this.selectedDate) || this.dates[0] || null
        }
    },
    watch: {
        selectedDate() {
            this.$nextTick(this.scrollSelectedIntoView)
        }
    },
    mounted() {
        this.scrollSelectedIntoView()
    },
    methods: {
        /** 将当前日期滚动到日期轨道的可视区域。 */
        scrollSelectedIntoView() {
            const items = Array.isArray(this.$refs.dateItems) ? this.$refs.dateItems : []
            const selected = items.find(item => item.dataset.date === this.selectedDate)
            if (selected && typeof selected.scrollIntoView === 'function') {
                selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.date-section {
    padding: 1.25rem 0 1rem;
    background: #fff;
}

.date-heading {
    display: flex;
    justify-content: center;
    gap: .5rem;
    margin-bottom: .875rem;
    color: #252525;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: .025em;
}

.date-track {
    display: flex;
    gap: .625rem;
    overflow-x: auto;
    padding: 0 1rem .25rem;
    scroll-behavior: smooth;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.date-item {
    display: flex;
    flex: 0 0 4rem;
    height: 4.75rem;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: .35rem 0;
    border: 1px solid #e6e6e6;
    border-radius: .5rem;
    color: #333;
    background: #fff;
    font-family: inherit;

    .weekday {
        font-size: .75rem;
        font-weight: 500;
    }

    .day {
        font-size: 1.125rem;
        font-weight: 700;
    }

    .indicator {
        width: 1.25rem;
        height: .125rem;
        border-radius: .625rem;
        background: #71ce00;
    }

    &.active {
        color: #fff;
        border-color: #1e3c3e;
        background: #1e3c3e;
    }

    &:focus-visible {
        outline: 2px solid #71ce00;
        outline-offset: 2px;
    }
}
</style>
